<template>
  <transition name="modal" appear>
    <div class="modal-overlay">
      <section class="modal-dialog wrap_confirm">
        <button class="btn_modal_close icon_btn" @click="$emit('close')"></button>
        <div class="text-center strong mb-2em" v-html="alertMessage"></div>
        <p class="text-center">
          <button ref="close" class="btn_modal_close" @click="$emit('close')">閉じる</button>
        </p>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["alertMessage"],
  mounted() {
      this.$refs.close.focus();
  }
};
</script>
<style scoped>
.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.modal-dialog {
  width: 80%;
  border-radius: 4px;
  background: #fff;
}
</style>
